import {renderFormField, useViewNavigate} from '@common'
import MenuIcon from '@mui/icons-material/Menu'
import {Breadcrumbs, Drawer, Link, Stack} from '@mui/material'

import React from 'react'

import {TitleLink} from 'common/types'

import {SideNavigation, UIKit} from '@components'

import {
  DropdownsWrapper,
  DropdownWrapper,
  TopBarLeftSectionWrapper,
  TopBarMenuButton,
  TopNavigationWrapper,
  DropdownLabel,
  LinkTitle,
  TopBarRightSectionWrapper,
  MainTitle,
} from './style'
import {useTopBarModel} from './top-bar-model'

interface Props {
  links: TitleLink[]
}

/**
 * Top Bar component present on all application screens
 */
export function TopBar(props: Props) {
  const {links} = props

  const navigate = useViewNavigate()

  const {formFields, setIsDrawerOpen, isDownLg, isDrawerOpen} = useTopBarModel()

  return (
    <>
      <TopNavigationWrapper>
        <TopBarLeftSectionWrapper>
          <Stack>
            <Breadcrumbs>
              {links.slice(0, links.length - (isDownLg ? 0 : 1)).map((linkItem, index) => {
                const {title, link} = linkItem
                const isLast = index === links.length - 1
                return (
                  <Link
                    underline="none"
                    key={`link-item-${title}`}
                    style={{cursor: 'pointer'}}
                    onClick={() => (link ? navigate(link) : undefined)}
                  >
                    <LinkTitle isLast={isLast}>{title}</LinkTitle>
                  </Link>
                )
              })}
            </Breadcrumbs>
            {!isDownLg && <MainTitle>{links[links.length - 1]?.title}</MainTitle>}
          </Stack>
        </TopBarLeftSectionWrapper>

        <TopBarRightSectionWrapper>
          <TopBarMenuButton onClick={() => setIsDrawerOpen(prev => !prev)}>
            <MenuIcon />
          </TopBarMenuButton>
          <DropdownsWrapper>
            {formFields.map((item, index) => (
              <DropdownWrapper key={`top-bar-dropdown-${index}-${item.label}`}>
                <Stack>
                  {'placeholder' in item && <DropdownLabel>{item.placeholder}</DropdownLabel>}
                  {renderFormField(item)}
                </Stack>
              </DropdownWrapper>
            ))}

            <UIKit.UserMenuButton />
          </DropdownsWrapper>
        </TopBarRightSectionWrapper>
      </TopNavigationWrapper>
      <Drawer open={isDrawerOpen} onClose={() => setIsDrawerOpen(false)}>
        <SideNavigation />
      </Drawer>
    </>
  )
}
